import { useRolexEventTracking } from '@lib/hooks/use-rolex-track-events'
import { useSyncRolexCmpTracking } from '@lib/hooks/use-sync-rolex-cmp-tracking'
import { useRolexTrackingScript } from '@lib/use-rolex-tracking-script-store'
import Script from 'next/script'
import { FC, useEffect, useState } from 'react'
import { RolexPageProps } from '.'

type RolexPagePageTypeTrackingProps = RolexPageProps
const environment = {
  environmentVersion: 'V7',
  coBrandedVersion: 'Bespoke',
}

// @ts-ignore
export const RolexPagePageTypeTracking: FC<RolexPagePageTypeTrackingProps> = (props) => {
  const { track } = useRolexEventTracking()
  const rolexConsent = useSyncRolexCmpTracking()
  const { setScriptIsLoaded, scriptIsLoaded } = useRolexTrackingScript()
  const [hasSetupDatalayer, setHasSetupDatalayer] = useState(false)
  const [hasTrackedPageView, setHasTrackedPageView] = useState(false)
  const adobeTrackingSrc =
    process.env.NEXT_PUBLIC_STAGE === 'production'
      ? '//assets.adobedtm.com/7e3b3fa0902e/db4a1bdd4eaa/launch-384bfb3a027c.min.js'
      : '//assets.adobedtm.com/7e3b3fa0902e/db4a1bdd4eaa/launch-98ac5c6226e2-staging.min.js'

  // 1. Make sure to populate window.digitalDataLayer with the correct data before loading the Rolex script,
  // otherwise the Rolex script will fire with incomplete data.
  useEffect(() => {
    if (hasSetupDatalayer) return
    const { pageType, productFamily, productRMC } = props
    window.digitalDataLayer = {
      environment,
      page: {
        pageType,
        pageFamilyName: productFamily || undefined,
      },
      ...(productRMC && {
        products: {
          productRMC,
        },
      }),
    }
    setHasSetupDatalayer(true)
  }, [props, hasSetupDatalayer])

  // 2. Track the page view event if the script is loaded and consent is given
  useEffect(() => {
    if (rolexConsent && scriptIsLoaded && !hasTrackedPageView) {
      track('pageView')
      setHasTrackedPageView(true)
    }
  }, [track, rolexConsent, scriptIsLoaded, hasTrackedPageView])

  return (
    rolexConsent &&
    hasSetupDatalayer && (
      <Script
        strategy="lazyOnload"
        onLoad={() => {
          setScriptIsLoaded()
        }}
        src={adobeTrackingSrc}
      />
    )
  )
}
